export const START_BIN = '1010';
export const END_BIN = '11101';

export const BINARIES = [
	'00110', '10001', '01001', '11000', '00101',
	'10100', '01100', '00011', '10010', '01010',
];
